import React from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { droneService, Header, DroneForm, useAppSelector } from "@shared/ui";

const CreateDrone: React.FC = () => {
  const { t } = useTranslation();
  const customer = useAppSelector((store) => store.customer.value);
  const navigate = useNavigate();

  const createDrone = (data: FieldValues) => {
    if (customer) {
      droneService
        .addDrone({
          name: data.name,
          description: data.description,
          type: data.type,
          customerId: customer.id,
          image: data.image,
          softwareVersion: data.softwareVersion
        })
        .then((data) => {
          navigate("/dashboard?tab=0");
        })
        .catch();
    }
  };
  return (
    <div className="form-page">
      <div className="container">
        <Header />

        <div className="form-wrapper">
          <h1 className="text-center">{t("createDrone.title")}</h1>

          <DroneForm onFormSubmitted={createDrone} />
        </div>
      </div>
    </div>
  );
};

export default CreateDrone;
